import React, {useState, useEffect, useCallback} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import {useTheme} from "@mui/material/styles";
import { API_URL } from "../config/apiConfig";
import {
    Container,
    Typography,
    Button,
    Box,
    Grid,
    useMediaQuery,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    ToggleButton,
    ToggleButtonGroup,
    CircularProgress,
    Menu,
    MenuItem,
    Checkbox,
    ListItemText,
    Chip,
    Fab
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import PersonIcon from "@mui/icons-material/Person";
import {Snackbar, Alert} from '@mui/material';
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import TodayIcon from "@mui/icons-material/Today";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents"; // Trophy icon for day leaderboard
import FilterListIcon from "@mui/icons-material/FilterList";
import ClassSchedule from "../components/ClassSchedule";
import TrainingModal from "../components/TrainingFormClasses";
import LeaderboardModal from "../components/LeaderboardModal";
import {getClassesForDay, assignTrainerToClasses, getClassesForSubdomain} from "../api/classesApi";
import TrainerAssignmentModal from "../components/TrainerAssignmentModal";
import {getUserFutureClasses, checkHomeAffiliate, fetchAffiliateInfo} from "../api/getClassesApi";
import ClassDetailsModal from "../components/ClassModal";
import {
    getClasses,
    deleteClass,
    createTraining,
    updateTraining,
    getClassAttendeesCount,
    uploadClassWorkoutImage,
    deleteClassWorkoutImage
} from "../api/classesApi";
import {getAffiliate} from "../api/affiliateApi";
import ClassWodView from "../components/ClassWodView";
import CapWeekView from "../components/CapWeekView";
import SmartLockUnlockButton from "../components/SmartLockUnlockButton";
import { getCapAvailability } from "../api/capApi";
import {getClassLeaderboard} from "../api/leaderboardApi";
import {getUserProfile} from "../api/profileApi";
import {getUserClassFilter, saveUserClassFilter} from "../api/userClassFilterApi";
import {EventAvailable} from "@mui/icons-material";
import { Card, CardContent } from "@mui/material";
import { cancelRegistration } from "../api/classesApi";
import { formatClassTimeOnly, formatClassDate, formatClassTime } from "../utils/classModalHelpers";

export default function Classes() {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const [showWODView, setShowWODView] = useState(false);
    const [showCapView, setShowCapView] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();
    const selectedAffiliate = location.state?.affiliate || null;
    const [affiliateId, setAffiliateId] = useState(null);
    const [paymentCountry, setPaymentCountry] = useState("EE");
    const [affiliateEmail, setAffiliateEmail] = useState(null);
    const [classes, setClasses] = useState([]);
    const [selectedTraining, setSelectedTraining] = useState(null);
    const [selectedClass, setSelectedClass] = useState(null);
    const [isTrainingModalOpen, setTrainingModalOpen] = useState(false);
    const [isWODModalOpen, setWODModalOpen] = useState(false);
    const [isClassModalOpen, setClassModalOpen] = useState(false);
    const [classModalRefreshKey, setClassModalRefreshKey] = useState(0);
    const [currentDate, setCurrentDate] = useState(new Date());
    const [trainers, setTrainers] = useState([]);
    const [registrationPeriod, setRegistrationPeriod] = useState(1); // Default to 7 days
    const [selectedDate, setSelectedDate] = useState(new Date());

    const todayIndex = new Date().getDay();
    const correctedIndex = todayIndex === 0 ? 6 : todayIndex - 1; // Sun (0) -> 6, Mon (1) -> 0, ..., Sat (6) -> 5
    const [selectedDayIndex, setSelectedDayIndex] = useState(correctedIndex);

    const [attendeesCount, setAttendeesCount] = useState({});
    const [showWeekly, setShowWeekly] = useState(false);
    const dayNames = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
    const [userRole, setUserRole] = useState(null);

    // Day leaderboard state
    const [isDayLeaderboardOpen, setDayLeaderboardOpen] = useState(false);
    const [dayLeaderboardFilter, setDayLeaderboardFilter] = useState("all");
    const [dayLeaderboardData, setDayLeaderboardData] = useState([]);
    const [loadingLeaderboard, setLoadingLeaderboard] = useState(false);
    const [userFullName, setUserFullName] = useState("");

    // Dialog states
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [classToDelete, setClassToDelete] = useState(null);
    const [successDialogOpen, setSuccessDialogOpen] = useState(false);
    const [errorDialogOpen, setErrorDialogOpen] = useState(false);
    const [dialogMessage, setDialogMessage] = useState('');

    // Add near other state declarations
    const [isTrainerAssignmentOpen, setTrainerAssignmentOpen] = useState(false);
    const [selectedTrainer, setSelectedTrainer] = useState(null);
    const [selectedAssignmentDate, setSelectedAssignmentDate] = useState(new Date());
    const [dayClasses, setDayClasses] = useState([]);
    const [selectedClassIds, setSelectedClassIds] = useState([]);

    const [notificationOpen, setNotificationOpen] = useState(false);
    const [notificationMessage, setNotificationMessage] = useState('');
    const [notificationSeverity, setNotificationSeverity] = useState('info'); // 'success', 'info', 'warning', 'error'
    const [refreshAfterRegistration, setRefreshAfterRegistration] = useState(false);

    // Registreeritud treeningute modal state
    const [isRegistrationsModalOpen, setRegistrationsModalOpen] = useState(false);
    const [userRegistrations, setUserRegistrations] = useState([]);
    const [loadingRegistrations, setLoadingRegistrations] = useState(false);

    const [isLoading, setIsLoading] = useState(true);

    const [cancelBeforeHours, setCancelBeforeHours] = useState(0); // Default to 1 hour

    // Add these state variables with your other state declarations
    const [cancelFutureClassConfirmOpen, setCancelFutureClassConfirmOpen] = useState(false);
    const [selectedClassToCancel, setSelectedClassToCancel] = useState(null);

    const [removeWaitlistConfirmOpen, setRemoveWaitlistConfirmOpen] = useState(false);
    const [selectedWaitlistToRemove, setSelectedWaitlistToRemove] = useState(null);
    const [isAllClassListVisible, setIsAllClassListVisible] = useState(false);
    const [showTrainerNamesInSchedule, setShowTrainerNamesInSchedule] = useState(true);
    const [workoutInfoVisibilityMode, setWorkoutInfoVisibilityMode] = useState("always");
    const [isCapAvailable, setIsCapAvailable] = useState(false);

    // Filter state
    const [filterAnchorEl, setFilterAnchorEl] = useState(null);
    const [selectedFilters, setSelectedFilters] = useState([]);
    const [filtersLoaded, setFiltersLoaded] = useState(false);
    const trainingTypeOptions = ["WOD", "Weightlifting", "Cardio", "Rowing", "Gymnastics", "Open Gym", "Kids", "Basic", "Hyrox", "Circuit", "Strength", "Hybrid", "Mobility", "Canoeing", "Other"];

    useEffect(() => {
        const role = localStorage.getItem("role");
        setUserRole(role);
    }, []);

    useEffect(() => {
        const loadCapAvailability = async () => {
            try {
                const response = await getCapAvailability();
                setIsCapAvailable(!!response?.isCapAvailable);
            } catch (error) {
                console.error("Error loading CAP availability:", error);
            }
        };
        loadCapAvailability();
    }, []);

    // Load user's saved filters when affiliateId is available
    useEffect(() => {
        const loadSavedFilters = async () => {
            if (affiliateId && !filtersLoaded) {
                console.log('📋 Loading saved filters for affiliate:', affiliateId);
                const savedFilters = await getUserClassFilter(affiliateId);
                if (savedFilters && savedFilters.length > 0) {
                    console.log('✅ Loaded saved filters:', savedFilters);
                    setSelectedFilters(savedFilters);
                }
                setFiltersLoaded(true);
            }
        };
        
        loadSavedFilters();
    }, [affiliateId, filtersLoaded]);

    // Reset filters when leaving the page
    useEffect(() => {
        return () => {
            setSelectedFilters([]);
            setFiltersLoaded(false);
        };
    }, [location.pathname]);

    // Fix affiliateId issue
    useEffect(() => {
        const fetchUserProfile = async () => {
            const role = localStorage.getItem("role");
            if (role === "affiliate") {


                try {
                    const profile = await getUserProfile();
                    if (profile && profile.fullName) {
                        setUserFullName(profile.fullName);
                    } else {
                        const storedName = localStorage.getItem('fullName');
                        if (storedName) setUserFullName(storedName);
                    }
                } catch (error) {
                    console.error("Error fetching user profile:", error);
                    const storedName = localStorage.getItem('fullName');
                    if (storedName) setUserFullName(storedName);
                }
            }
        };

        fetchUserProfile();
    }, []);

    // Set up affiliateId in a more reliable way
    useEffect(() => {
        // Set up affiliateId from various sources
        if (selectedAffiliate && selectedAffiliate.id) {

            setAffiliateId(selectedAffiliate.id);
            if (selectedAffiliate.paymentCountry) {
                setPaymentCountry(selectedAffiliate.paymentCountry);
            } else {
                fetchAffiliateInfo(selectedAffiliate.id).then((info) => {
                    setPaymentCountry(info?.affiliate?.paymentCountry || "EE");
                });
            }
            setRegistrationPeriod(selectedAffiliate.registrationPeriod);
            setCancelBeforeHours(selectedAffiliate.cancelBeforeHours ?? 1); // Default to 1 hour if not set
            setIsAllClassListVisible(selectedAffiliate.isAllClassListVisible ?? false);
            setShowTrainerNamesInSchedule(selectedAffiliate.showTrainerNamesInSchedule !== false);
            setWorkoutInfoVisibilityMode(selectedAffiliate.workoutInfoVisibilityMode || "always");
            if (selectedAffiliate.trainers) {
                setTrainers(selectedAffiliate.trainers);
            }

            return; // Exit early if we have a selectedAffiliate
        }

        const storedId = localStorage.getItem("affiliateId");
        if (storedId) {

            const parsedStoredId = parseInt(storedId, 10);
            setAffiliateId(parsedStoredId);
        }

        // Fetch from API - different endpoints for affiliate/trainer vs regular users
        const fetchAffiliate = async () => {
            const role = localStorage.getItem("role");
            try {
                // Trainer must always resolve affiliate from trainer context, never from home gym endpoints.
                if (role === "trainer") {
                    let trainerAffiliateId = null;
                    const parsedStoredId = storedId ? parseInt(storedId, 10) : null;

                    const response = await fetch(`${API_URL}/trainer/affiliates`, {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json",
                            "Authorization": `Bearer ${localStorage.getItem("token")}`,
                        },
                    });

                    if (response.ok) {
                        const trainerAffiliates = await response.json();
                        const validTrainerAffiliates = Array.isArray(trainerAffiliates) ? trainerAffiliates : [];

                        // Use stored affiliate only if it's actually one of trainer's affiliates.
                        const hasStoredTrainerAffiliate = parsedStoredId
                            ? validTrainerAffiliates.some((aff) => Number(aff.id) === Number(parsedStoredId))
                            : false;

                        if (hasStoredTrainerAffiliate) {
                            trainerAffiliateId = parsedStoredId;
                        } else if (validTrainerAffiliates.length === 1) {
                            trainerAffiliateId = validTrainerAffiliates[0].id;
                            localStorage.setItem("affiliateId", String(trainerAffiliateId));
                        } else if (validTrainerAffiliates.length > 1) {
                            // Trainer has multiple affiliates but none selected yet - force selection screen.
                            navigate("/trainer", { replace: true });
                            return;
                        }
                    }

                    if (trainerAffiliateId) {
                        const affiliateInfo = await fetchAffiliateInfo(trainerAffiliateId);
                        if (affiliateInfo?.affiliate) {
                            const aff = affiliateInfo.affiliate;
                            setAffiliateId(aff.id);
                            setPaymentCountry(aff.paymentCountry || "EE");
                            setAffiliateEmail(aff.email || null);
                            setRegistrationPeriod(aff.registrationPeriod || 1);
                            setCancelBeforeHours(aff.cancelBeforeHours ?? 1);
                            setIsAllClassListVisible(aff.isAllClassListVisible ?? false);
                            setShowTrainerNamesInSchedule(aff.showTrainerNamesInSchedule !== false);
                            setWorkoutInfoVisibilityMode(aff.workoutInfoVisibilityMode || "always");
                            if (affiliateInfo.trainers && Array.isArray(affiliateInfo.trainers)) {
                                setTrainers(affiliateInfo.trainers);
                            }
                            return;
                        }
                    }

                    // Could not resolve a trainer affiliate, return without falling back to home gym logic.
                    return;
                }

                // Affiliate/trainer: getAffiliate() calls /my-affiliate
                // Regular user: getAffiliate() returns null - use checkHomeAffiliate instead
                if (role === "regular") {
                    const homeAffiliateData = await checkHomeAffiliate();
                    if (homeAffiliateData?.homeAffiliate) {
                        const affiliateInfo = await fetchAffiliateInfo(homeAffiliateData.homeAffiliate);
                        if (affiliateInfo?.affiliate) {
                            const aff = affiliateInfo.affiliate;
                            setAffiliateId(aff.id);
                            setPaymentCountry(aff.paymentCountry || "EE");
                            setAffiliateEmail(aff.email || null);
                            setRegistrationPeriod(aff.registrationPeriod || 1);
                            setCancelBeforeHours(aff.cancelBeforeHours ?? 1);
                            setIsAllClassListVisible(aff.isAllClassListVisible ?? false);
                            setShowTrainerNamesInSchedule(aff.showTrainerNamesInSchedule !== false);
                            setWorkoutInfoVisibilityMode(aff.workoutInfoVisibilityMode || "always");
                            if (affiliateInfo.trainers && Array.isArray(affiliateInfo.trainers)) {
                                setTrainers(affiliateInfo.trainers);
                            }
                            return;
                        }
                    }
                    // Regular user without home gym - redirect to register
                    navigate("/register-training", { replace: true });
                } else {
                    let response = await getAffiliate();

                    if (response && response.affiliate && response.affiliate.id) {

                        setAffiliateId(response.affiliate.id);
                        setPaymentCountry(response.affiliate.paymentCountry || "EE");
                        setAffiliateEmail(response.affiliate.email);
                        setRegistrationPeriod(response.registrationPeriod || 1);
                        setIsAllClassListVisible(response.affiliate.isAllClassListVisible ?? false);
                        setShowTrainerNamesInSchedule(response.affiliate.showTrainerNamesInSchedule !== false);
                        setWorkoutInfoVisibilityMode(response.affiliate.workoutInfoVisibilityMode || "always");

                        if (response.trainers && Array.isArray(response.trainers)) {
                            setTrainers(response.trainers);
                        }

                    } else if (response && response.id) {

                        setAffiliateId(response.id);
                        setPaymentCountry(response.paymentCountry || "EE");
                        if (response.email) setAffiliateEmail(response.email);
                        setRegistrationPeriod(response.registrationPeriod || 1);
                        setIsAllClassListVisible(response.isAllClassListVisible ?? false);
                        setShowTrainerNamesInSchedule(response.showTrainerNamesInSchedule !== false);
                        setWorkoutInfoVisibilityMode(response.workoutInfoVisibilityMode || "always");

                    }
                }
            } catch (error) {
                console.error("Error fetching affiliate:", error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchAffiliate();

    }, [selectedAffiliate, navigate]);

    // Set userRole


    // Show success message
    const showSuccessMessage = (message) => {
        setDialogMessage(message);
        setSuccessDialogOpen(true);
    };

    // Show error message
    const showErrorMessage = (message) => {
        setDialogMessage(message);
        setErrorDialogOpen(true);
    };

    // Modified fetchClasses to not warn about null affiliateId
    const fetchClasses = useCallback(async () => {
        if (!affiliateId) {
            return; // Just return silently without a warning
        }
        const role = localStorage.getItem("role");
        const startOfWeek = new Date(currentDate);
        startOfWeek.setDate(startOfWeek.getDate() - (startOfWeek.getDay() === 0 ? 6 : startOfWeek.getDay() - 1));
        startOfWeek.setHours(0, 0, 0, 0);

        const endOfWeek = new Date(startOfWeek);
        endOfWeek.setDate(startOfWeek.getDate() + 6);
        endOfWeek.setHours(23, 59, 59, 999);

        try {
            if (role) {
                const response = await getClasses(affiliateId, startOfWeek);
                setClasses(response || []);
            } else {
                const response = await getClassesForSubdomain(affiliateId, startOfWeek);
                setClasses(response || []);
            }

        } catch (error) {
            console.error("❌ Fetch error:", error);
            setClasses([]);

        }
    }, [affiliateId, currentDate]);

    // Dedicated effect to call fetchClasses when affiliateId changes
    useEffect(() => {


        if (affiliateId) {

            fetchClasses();

            setTimeout(() => {
                setIsLoading(false);
            }, 300);

        }

    }, [affiliateId, fetchClasses]);

    // Re-fetch classes when user returns to tab (fixes empty page on Android Chrome after tab was in background)
    useEffect(() => {
        const handleVisibilityChange = () => {
            if (document.visibilityState === 'visible' && affiliateId) {
                fetchClasses();
            }
        };
        document.addEventListener('visibilitychange', handleVisibilityChange);
        return () => document.removeEventListener('visibilitychange', handleVisibilityChange);
    }, [affiliateId, fetchClasses]);


    // Get classes for selected day
    const getClassesForSelectedDay = (dayIndex) => {
        const startOfWeek = new Date(currentDate);
        startOfWeek.setDate(startOfWeek.getDate() - (startOfWeek.getDay() || 7) + 1 + dayIndex);

        let filteredClasses = classes.filter((cls) => {
            const classDate = new Date(cls.time);
            return (
                classDate.getFullYear() === startOfWeek.getFullYear() &&
                classDate.getMonth() === startOfWeek.getMonth() &&
                classDate.getDate() === startOfWeek.getDate()
            );
        });

        // Apply training type filter
        if (selectedFilters.length > 0) {
            filteredClasses = filteredClasses.filter(cls => 
                selectedFilters.includes(cls.trainingType)
            );
        }

        return filteredClasses;
    };

    const showNotification = (message, severity = 'info') => {
        setNotificationMessage(message);
        setNotificationSeverity(severity);
        setNotificationOpen(true);
    };

    const handleRegistrationSuccess = (result) => {
        setRefreshAfterRegistration(true);
        setClassModalOpen(false);
        if (result?.calendarMessage) {
            showNotification(`Successfully registered! ${result.calendarMessage}`, "warning");
        } else {
            showNotification("Successfully registered!", "success");
        }
    };

    const handleClassModalExited = () => {
        if (refreshAfterRegistration) {
            setRefreshAfterRegistration(false);
            fetchClasses();
        }
    };

    // Add this function inside the Classes component
    const getBackgroundColor = (trainingType) => {
        switch(trainingType) {
            case "WOD":
                return "#f0faff"; // light blue
            case "Weightlifting":
                return "#f0fff5"; // light green
            case "Cardio":
                return "#fff5f5"; // light red
            case "Rowing":
                return "#f9f0ff"; // light purple
            case "Gymnastics":
                return "#fff0f9"; // light pink
            case "Open Gym":
                return "#f5f0e1"; // light brown
            case "Kids":
                return "#cae1ca"; // light yellow-green
            case "Basic":
                return "#f0f0ff"; // light gray
            case "Hyrox":
                return "#ffe9e9"; // light sky-blue
            case "Hybrid":
                return "#ffe9e9"; // light blue
            default:
                return "background.paper";
        }
    };

    // Add these handler functions
    const handleOpenCancelFutureClass = (classRegistration) => {
        setSelectedClassToCancel(classRegistration);
        setCancelFutureClassConfirmOpen(true);
    };

    const handleCloseCancelFutureClass = () => {
        setCancelFutureClassConfirmOpen(false);
        setSelectedClassToCancel(null);
    };

    const handleConfirmCancelFutureClass = async () => {
        if (!selectedClassToCancel) return;

        try {
            // Determine if this is a family member registration
            const isFamilyMember = selectedClassToCancel.isFamilyMember;

            if (isFamilyMember) {
                // Use family member cancellation API
                const response = await fetch(`${process.env.REACT_APP_API_URL}/classes/cancel-family-member`, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${localStorage.getItem('token')}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        enrollmentId: selectedClassToCancel.enrollmentId, // You'll need to ensure this is available
                        freeClass: selectedClassToCancel.freeClass
                    })
                });

                if (!response.ok) {
                    throw new Error('Failed to cancel family member registration');
                }
            } else {
                // Use regular cancellation API
                await cancelRegistration(selectedClassToCancel.id, selectedClassToCancel.freeClass);
            }

            // Refresh the registrations list
            await handleOpenRegistrationsModal();
            showNotification("Registration cancelled successfully!", "success");
        } catch (error) {
            console.error("Error cancelling registration:", error);
            showNotification("Failed to cancel registration", "error");
        } finally {
            handleCloseCancelFutureClass();
        }
    };

    const handleClassModalClose = () => {
        setClassModalOpen(false);
        // Kontrolli kas klass tuli My Future Classes'ist
        if (selectedClass && userRegistrations.some(reg => reg.id === selectedClass.id)) {
            // Värskenda My Future Classes nimekirja
            handleOpenRegistrationsModal();
        }
    };

    // Fetch leaderboard data for all WOD classes on the selected day
    const fetchDayLeaderboard = async (dayIndex) => {
        try {
            setLoadingLeaderboard(true);

            // Get all WOD classes for the selected day
            const dayClasses = getClassesForSelectedDay(dayIndex);
            const wodClasses = dayClasses.filter(cls => cls.trainingType === "WOD");

            if (wodClasses.length === 0) {
                showErrorMessage("No WOD classes found for this day");
                setLoadingLeaderboard(false);
                return;
            }

            // Fetch leaderboard data for each WOD class
            const leaderboardPromises = wodClasses.map(cls => getClassLeaderboard(cls.id));
            const leaderboardResults = await Promise.all(leaderboardPromises);

            // Combine all leaderboard results and add the class name to each entry
            const combinedLeaderboard = [];
            leaderboardResults.forEach((results, index) => {
                if (Array.isArray(results) && results.length > 0) {
                    const classData = wodClasses[index];
                    const classLeaderboard = results.map(entry => ({
                        ...entry,
                        className: classData.trainingName,
                        wodName: classData.wodName || "WOD",
                        classTime: formatClassTimeOnly(classData.time),
                        classId: classData.id
                    }));
                    combinedLeaderboard.push(...classLeaderboard);
                }
            });

            setDayLeaderboardData(combinedLeaderboard);
            setLoadingLeaderboard(false);

            // If we have data, open the leaderboard modal
            if (combinedLeaderboard.length > 0) {
                setDayLeaderboardOpen(true);
            } else {
                showNotification("No leaderboard entries found for WOD classes today");
            }

        } catch (error) {
            console.error("Error fetching day leaderboard:", error);
            showErrorMessage("Error loading leaderboard data");
            setLoadingLeaderboard(false);
        }
    };

    // Open day leaderboard
    const handleOpenDayLeaderboard = () => {
        fetchDayLeaderboard(selectedDayIndex);
    };

    // Handle leaderboard filter change
    const handleDayLeaderboardFilterChange = (event, newFilter) => {
        if (newFilter) {
            setDayLeaderboardFilter(newFilter);
        }
    };

    // Filter the day leaderboard data
    const filteredDayLeaderboard = dayLeaderboardData.filter(entry =>
        dayLeaderboardFilter === "all" || entry.scoreType?.toLowerCase() === dayLeaderboardFilter
    );

    const handlePrevWeek = () => {
        const newDate = new Date(currentDate);
        newDate.setDate(currentDate.getDate() - 7);
        setCurrentDate(newDate);
        setSelectedDayIndex(0);
    };

    const handleToday = () => {
        const today = new Date();
        setCurrentDate(today);

        // Set the selected day to today
        const todayIndex = today.getDay();
        const correctedIndex = todayIndex === 0 ? 6 : todayIndex - 1;
        setSelectedDayIndex(correctedIndex);
    };

    const handleNextWeek = () => {
        const newDate = new Date(currentDate);
        newDate.setDate(currentDate.getDate() + 7);
        setCurrentDate(newDate);
        setSelectedDayIndex(0);
    };

    const handleDaySelect = (index) => {
        setSelectedDayIndex(index);
    };

    const handleAddTraining = () => {
        setSelectedTraining(null);
        setTrainingModalOpen(true);
    };

    // ✅ Funktsioon treeningu salvestamiseks
    const handleSaveTraining = async (trainingData) => {
        if (!affiliateId) {
            console.error("❌ Cannot save training: affiliateId is null");
            showErrorMessage("Cannot save training: missing affiliate ID");
            return;
        }

        if (!trainingData || typeof trainingData !== "object") {
            console.error("❌ Invalid training data:", trainingData);
            showErrorMessage("Invalid training data provided");
            return;
        }

        try {
            const { workoutImageFile, removeWorkoutImage, ...trainingPayload } = trainingData;
            let savedClassId = trainingData.id || null;

            if (trainingData.id) {
                const updateResponse = await updateTraining(trainingData.id, trainingPayload); // ✅ Teeme update
                savedClassId = updateResponse?.class?.id || savedClassId;
                showSuccessMessage("Training updated successfully!");

                if (selectedClass && selectedClass.id === trainingData.id) {
                    setSelectedClass({
                        ...selectedClass,
                        ...trainingPayload,
                        temporaryTrainerId: trainingPayload.temporaryTrainerId || null,
                        temporaryTrainerName: trainingPayload.temporaryTrainerId
                            ? (trainingPayload.trainer || selectedClass.temporaryTrainerName || null)
                            : null
                    });
                }

            } else {
                const createResponse = await createTraining(affiliateId, trainingPayload); // ✅ Loome uue klassi
                savedClassId = createResponse?.class?.id || savedClassId;
                showSuccessMessage("New training created successfully!");
            }

            if (savedClassId && removeWorkoutImage) {
                await deleteClassWorkoutImage(savedClassId);
            }

            if (savedClassId && workoutImageFile) {
                await uploadClassWorkoutImage(savedClassId, workoutImageFile);
            }

            if (selectedClass && selectedClass.id === savedClassId) {
                setClassModalRefreshKey((prev) => prev + 1);
            }

            setTrainingModalOpen(false);
            fetchClasses(); // ✅ Uuenda klasside nimekirja
        } catch (error) {
            console.error("❌ Error saving training:", error);
            showErrorMessage("Error saving training: " + (error.message || "Unknown error"));
        }
    };

    const handleEditTraining = (training) => {
        setSelectedTraining(training);
        setTrainingModalOpen(true);
    };

    // Open delete confirmation dialog
    const handleOpenDeleteConfirm = (classId) => {
        setClassToDelete(classId);
        setConfirmDialogOpen(true);
    };

    // Delete class after confirmation
    const handleConfirmDeleteClass = async () => {
        if (!classToDelete) return;

        try {
            await deleteClass(classToDelete);
            fetchClasses();
            setClassModalOpen(false);
            showSuccessMessage("Class deleted successfully!");
        } catch (error) {
            console.error("❌ Error deleting class:", error);
            showErrorMessage("Error deleting class: " + (error.message || "Unknown error"));
        }
        setConfirmDialogOpen(false);
        setClassToDelete(null);
    };

    // Handle the delete button click
    const handleDeleteClass = async (classId) => {
        try {
            await deleteClass(classId);
            await fetchClasses();
            setClassModalOpen(false);
            showSuccessMessage("Class deleted successfully!");
        } catch (error) {
            console.error("❌ Error deleting class:", error);
            showErrorMessage("Error deleting class: " + (error.message || "Unknown error"));
            throw error; // Re-throw so ClassModal can handle the error state
        }
    };

    const handleEditClass = (cls) => {
        setSelectedTraining(cls);
        setTrainingModalOpen(true);
    };

    const handleClassClick = (cls) => {
        setSelectedClass(cls);
        setClassModalOpen(true);
    };

    // Check if there are any WOD classes for the selected day
    const hasWodClasses = getClassesForSelectedDay(selectedDayIndex).some(cls => cls.trainingType === "WOD");

    // Format date for display
    const getFormattedDate = () => {
        const startOfWeek = new Date(currentDate);
        startOfWeek.setDate(startOfWeek.getDate() - (startOfWeek.getDay() || 7) + 1);
        startOfWeek.setHours(0, 0, 0, 0);

        const date = new Date(startOfWeek);
        date.setDate(startOfWeek.getDate() + selectedDayIndex);

        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();

        return `${day}.${month}.${year}`;
    };

    const handleOpenTrainerAssignment = () => {
        const today = new Date();
        setSelectedTrainer(null);
        setSelectedClassIds([]);
        setSelectedAssignmentDate(today);
        setTrainerAssignmentOpen(true);

        fetchClassesForDay(today);
    };

    const fetchClassesForDay = async (date) => {
        if (!affiliateId) return;

        const formattedDate = date.toISOString().split('T')[0];

        try {
            const response = await getClassesForDay(affiliateId, formattedDate);
            setDayClasses(response || []);
        } catch (error) {
            console.error("❌ Error fetching classes for day:", error);
            showErrorMessage("Error loading classes for selected day");
            setDayClasses([]);
        }
    };

    const handleDateChange = (date) => {
        setSelectedAssignmentDate(date);
        setSelectedClassIds([]);
        fetchClassesForDay(date);
    };

    const handleTrainerChange = (trainerId) => {
        // Leia õige treener ID järgi
        const trainer = trainers.find(t =>
            (t.trainerId === parseInt(trainerId)) ||
            (t.id === parseInt(trainerId))
        );
        setSelectedTrainer(trainer);
    };

    const handleClassCheckboxChange = (classId) => {
        setSelectedClassIds(prev => {
            if (prev.includes(classId)) {
                return prev.filter(id => id !== classId);
            } else {
                return [...prev, classId];
            }
        });
    };

    const handleAssignTrainer = async () => {
        if (!selectedTrainer) {
            showErrorMessage("Please select a trainer");
            return;
        }

        if (selectedClassIds.length === 0) {
            showErrorMessage("Please select at least one class");
            return;
        }

        // Leia korrektne treeneri nimi
        let trainerName = "";
        if (typeof selectedTrainer === 'string') {
            trainerName = selectedTrainer;
        } else if (selectedTrainer.fullName) {
            trainerName = selectedTrainer.fullName;
        } else if (selectedTrainer.trainer && selectedTrainer.trainer.fullName) {
            trainerName = selectedTrainer.trainer.fullName;
        } else {
            showErrorMessage("Could not determine trainer name");
            return;
        }

        try {
            const response = await assignTrainerToClasses(selectedClassIds, trainerName);

            // ✅ Ära sulge modali, nullita ainult valitud klassid
            setSelectedClassIds([]); // Nullita valitud klassid

            // Värskenda klassid valitud kuupäevale
            fetchClassesForDay(selectedAssignmentDate);

            // Värskenda ka peamist klasside nimekirja
            fetchClasses();

            showSuccessMessage("Trainer assigned successfully!");
        } catch (error) {
            console.error("❌ Error assigning trainer:", error);
            showErrorMessage("Error assigning trainer to classes: " + (error.message || "Unknown error"));
        }
    };



    // Handle remove from waitlist
    const handleRemoveFromWaitlist = (classRegistration) => {
        setSelectedWaitlistToRemove(classRegistration);
        setRemoveWaitlistConfirmOpen(true);
    };

    const handleCloseRemoveWaitlist = () => {
        setRemoveWaitlistConfirmOpen(false);
        setSelectedWaitlistToRemove(null);
    };

    const handleOpenRegistrationsModal = async () => {
        setLoadingRegistrations(true);
        setRegistrationsModalOpen(true);

        try {
            // Kasuta uut API-d, mis otsib kõik tuleviku klassid
            const futureClasses = await getUserFutureClasses();

            // Klassid on juba sorteeritud aja järgi (lähimad esimesed)
            setUserRegistrations(futureClasses);

            console.log("Loaded future classes:", futureClasses.length);

        } catch (error) {
            console.error("Error loading future classes:", error);
            showErrorMessage("Error loading your future classes");
            setUserRegistrations([]);
        } finally {
            setLoadingRegistrations(false);
        }
    };

    // Filter handlers
    const handleFilterClick = (event) => {
        setFilterAnchorEl(event.currentTarget);
    };

    const handleFilterClose = () => {
        setFilterAnchorEl(null);
    };

    const handleFilterToggle = async (type) => {
        const newFilters = selectedFilters.includes(type)
            ? selectedFilters.filter((t) => t !== type)
            : [...selectedFilters, type];
        
        setSelectedFilters(newFilters);
        
        // Save filters to database
        if (affiliateId) {
            console.log('💾 Saving filters:', newFilters);
            await saveUserClassFilter(affiliateId, newFilters);
        }
    };

    const handleClearFilters = async () => {
        setSelectedFilters([]);
        
        // Save empty filters to database
        if (affiliateId) {
            console.log('🗑️ Clearing filters');
            await saveUserClassFilter(affiliateId, []);
        }
    };
    return (
        <Container
            maxWidth={false}
            sx={{
                pl: {xs: 0, md: 2, lg: 2},
                pr: {xs: 0, md: 2, lg: 2},
                pt: {xs: 1, md: 2},
                pb: {xs: "88px", md: 2}, // Ruum alumise mobiilinavi jaoks
            }}
        >
            <Box textAlign="center" my={1}>
                {isLoading && (
                    <Box
                        sx={{
                            position: 'absolute',
                            top: 50,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            backgroundColor: 'rgba(255, 255, 255, 0.7)',
                            zIndex: 999
                        }}
                    >
                        <CircularProgress size={60} />
                    </Box>
                )}
                <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    my={{ xs: 1, sm: 3 }}
                    px={2}
                >
                    {/* Left side: Affiliate name and title */}
                    <Box>
                        {selectedAffiliate?.name && (
                            <Typography variant="h4" color="primary" sx={{ mb: 0 }}>
                                {selectedAffiliate.name}
                            </Typography>
                        )}

                    </Box>

                    {/* Right side: Trophy - less padding on mobile */}
                    <Box sx={{ m: { xs: -0.5, sm: 0 } }}>
                        {hasWodClasses && !showWeekly && !showWODView && !showCapView && (
                            <IconButton
                                color="primary"
                                onClick={handleOpenDayLeaderboard}
                                size="small"
                                sx={{
                                    color: "goldenrod",
                                    p: { xs: 0.5, sm: 1 },
                                    "&:hover": {
                                        backgroundColor: "rgba(218,165,32,0.1)"
                                    }
                                }}
                            >
                                <EmojiEventsIcon sx={{ fontSize: { xs: 22, sm: 28 } }} />
                            </IconButton>
                        )}
                    </Box>
                </Box>

                {/* ✅ Buttons - side by side, wrap on small screens */}
                <Box
                    display="flex"
                    flexDirection="row"
                    flexWrap="wrap"
                    justifyContent={{ xs: "space-between", sm: "center" }}
                    alignItems="center"
                    gap={{ xs: 0.5, sm: 1 }}
                    sx={{
                        width: "100%",
                        "& .MuiButton-root": { m: { xs: 0, sm: 1 } }
                    }}
                >
                {(userRole === "affiliate" || userRole === "trainer") && !showCapView && (
                    showWODView ? (
                        <Button
                            sx={{
                                width: { xs: "100%", sm: "auto" }
                            }}
                            variant="contained"
                            color="primary"
                            onClick={() => setShowWODView(false)}
                        >
                            Show Classes
                        </Button>
                    ) : (
                        <Button sx={{ width: { xs: "100%", sm: "auto" } }} variant="contained" color="primary" onClick={() => setShowWODView(true)}>
                            WOD Programming
                        </Button>
                    )

                )}

                {(userRole === "affiliate" || userRole === "trainer") && !showWODView && !showCapView && (
                    <Button sx={{ width: { xs: "100%", sm: "auto" } }} variant="contained" color="primary" onClick={handleAddTraining}>
                        Add Classes
                    </Button>
                )}
                {(userRole === "affiliate" || userRole === "trainer") && !showWODView && !showCapView && (
                    <Button sx={{ width: { xs: "100%", sm: "auto" } }} variant="contained" color="primary" onClick={handleOpenTrainerAssignment}>
                        Add Coaches
                    </Button>
                )}
                {userRole === "affiliate" && isCapAvailable && (showWODView || showCapView) && (
                    <Button
                        sx={{
                            width: { xs: "100%", sm: "auto" }
                        }}
                        variant="contained"
                        color="primary"
                        onClick={() => {
                            if (showCapView) {
                                setShowCapView(false);
                                setShowWODView(true);
                            } else {
                                setShowCapView(true);
                                setShowWODView(true);
                            }
                        }}
                    >
                        {showCapView ? "Show WOD" : "CAP"}
                    </Button>
                )}
                </Box>

                {(userRole === "affiliate" || userRole === "trainer") && !showWODView && !showCapView && (
                    <Box sx={{ mt: { xs: 1.5, sm: 1 }, width: "100%" }}>
                        <SmartLockUnlockButton
                            affiliateId={affiliateId}
                            disabled={!affiliateId}
                            fullWidth
                            eligibleOnly
                        />
                    </Box>
                )}

            </Box>

            {/* ✅ Kuvab kas WOD vaate või klasside vaate */}
            {showCapView && userRole === "affiliate" ? (
                <CapWeekView affiliateId={affiliateId} paymentCountry={paymentCountry} onApplied={fetchClasses} />
            ) : showWODView ? (
                <ClassWodView affiliateId={affiliateId} paymentCountry={paymentCountry} fetchClasses={fetchClasses} selectedAffiliateId={affiliateId}
                              onClose={() => setShowWODView(false)}/>
            ) : (
                <>
                    {/* ✅ Nädala ja päeva vahetus */}
                    <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                        mb={2}
                        sx={{
                            position: 'sticky',
                            top: 0,
                            backgroundColor: 'background.default', // Võib olla 'white' või theme.palette.background.default
                            zIndex: 1000,
                            py: 0, // Vertikaalne padding
                            borderBottom: '1px solid rgba(0,0,0,0.12)', // Valikuline eraldaja
                        }}
                    >
                        <IconButton
                            color="primary"
                            onClick={handlePrevWeek}
                            sx={{bgcolor: 'rgba(0, 0, 0, 0.04)'}}
                        >
                            <ArrowBackIosNewIcon/>
                        </IconButton>

                        {!showWeekly && (
                            <Box display="flex" alignItems="center">
                                <Typography variant="h6" sx={{mr: 1}}>
                                    {getFormattedDate()}
                                </Typography>
                                <Button
                                    variant="outlined"
                                    size="small"
                                    startIcon={<TodayIcon/>}
                                    onClick={handleToday}
                                >
                                    Today
                                </Button>
                            </Box>
                        )}

                        {!isMobile && (
                            <Box
                                sx={{
                                    display: "flex",
                                    p: "3px",
                                    borderRadius: "10px"
                                }}
                            >
                                <Button
                                    size="small"
                                    onClick={() => setShowWeekly(false)}
                                    sx={{
                                        minWidth: 78,
                                        textTransform: "none",
                                        borderRadius: "8px",
                                        fontWeight: 600,
                                        color: showWeekly ? "#4a4a4a" : "#ffffff",
                                        bgcolor: showWeekly ? "transparent" : "#1f2338",
                                        "&:hover": {
                                            bgcolor: showWeekly ? "rgba(0,0,0,0.05)" : "#1f2338"
                                        }
                                    }}
                                >
                                    As Day
                                </Button>
                                <Button
                                    size="small"
                                    onClick={() => setShowWeekly(true)}
                                    sx={{
                                        minWidth: 78,
                                        textTransform: "none",
                                        borderRadius: "8px",
                                        fontWeight: 600,
                                        color: showWeekly ? "#ffffff" : "#4a4a4a",
                                        bgcolor: showWeekly ? "#1f2338" : "transparent",
                                        "&:hover": {
                                            bgcolor: showWeekly ? "#1f2338" : "rgba(0,0,0,0.05)"
                                        }
                                    }}
                                >
                                    As Week
                                </Button>
                            </Box>
                        )}
                        {!isMobile && (
                            <Button 
                                variant="outlined" 
                                color="primary" 
                                startIcon={<FilterListIcon />}
                                onClick={handleFilterClick}
                                sx={{
                                    position: 'relative',
                                    '&::after': selectedFilters.length > 0 ? {
                                        content: `"${selectedFilters.length}"`,
                                        position: 'absolute',
                                        top: -8,
                                        right: -8,
                                        backgroundColor: 'error.main',
                                        color: 'white',
                                        borderRadius: '50%',
                                        width: 20,
                                        height: 20,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        fontSize: '0.75rem',
                                        fontWeight: 'bold'
                                    } : {}
                                }}
                            >
                                Filter
                            </Button>
                        )}
                        {userRole === "regular" && (
                            <IconButton
                                color="primary"
                                onClick={handleOpenRegistrationsModal}
                            >
                                <EventAvailable/>
                            </IconButton>
                        )}

                        <IconButton
                            color="primary"
                            onClick={handleNextWeek}
                            sx={{bgcolor: 'rgba(0, 0, 0, 0.04)'}}
                        >
                            <ArrowForwardIosIcon/>
                        </IconButton>
                    </Box>

                    {/* ✅ Kui showWeekly = false -> päeva kaupa */}
                    {!showWeekly && (
                        <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            gap={1}
                            p={1}
                            sx={{
                                position: 'sticky',
                                top: 35, // Kohanda vastavalt eelmise sticky elemendi kõrgusele
                                backgroundColor: 'background.default',
                                zIndex: 999, // Madalam kui ülemisel navigatsioonil
                                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                overflowX: "auto",
                                whiteSpace: "nowrap",
                                flexWrap: "nowrap",
                            }}
                        >
                            {dayNames.map((day, index) => (
                                <Button
                                    key={index}
                                    variant={selectedDayIndex === index ? "contained" : "outlined"}
                                    color={selectedDayIndex === index ? "primary" : "default"}
                                    onClick={() => handleDaySelect(index)}
                                    sx={{
                                        minWidth: {xs: "40px", sm: "80px"},
                                        flexGrow: 1,
                                        fontSize: {xs: "0.75rem", sm: "1rem"},
                                        padding: {xs: "4px", sm: "8px"},
                                    }}
                                >
                                    {day}
                                </Button>
                            ))}
                        </Box>
                    )}

                    {/* ✅ Kui showWeekly = true -> nädalane vaade */}
                    {showWeekly ? (
                        <Grid container spacing={2}>
                            {dayNames.map((day, index) => {
                                const dailyClasses = getClassesForSelectedDay(index);
                                const dayDate = new Date(currentDate);
                                dayDate.setDate(dayDate.getDate() - (dayDate.getDay() || 7) + 1 + index);
                                const hasWodClassesForDay = dailyClasses.some(cls => cls.trainingType === "WOD");

                                return (
                                    <Grid item xs={12} sm={6} md={1.7} lg={1.7} key={index}>
                                        <Box textAlign="center">
                                            <Box display="flex" alignItems="center" justifyContent="center">
                                                <Typography variant="h6" sx={{fontWeight: "bold", my: 1}}>
                                                    {day} - {dayDate.toLocaleDateString("en-GB")}
                                                </Typography>

                                                {/* Day Leaderboard Trophy Icon for weekly view */}
                                                {hasWodClassesForDay && (
                                                    <IconButton
                                                        color="primary"
                                                        onClick={() => {
                                                            const newIndex = index;
                                                            setSelectedDayIndex(newIndex);
                                                            fetchDayLeaderboard(newIndex);
                                                        }}
                                                        size="small"
                                                        sx={{
                                                            ml: 0.5,
                                                            color: "goldenrod",
                                                            "&:hover": {
                                                                backgroundColor: "rgba(218,165,32,0.1)"
                                                            }
                                                        }}
                                                    >
                                                        <EmojiEventsIcon fontSize="small"/>
                                                    </IconButton>
                                                )}
                                            </Box>
                                            <ClassSchedule
                                                classes={dailyClasses}
                                                attendeesCount={attendeesCount}
                                                onEdit={handleEditTraining}
                                                onClassClick={handleClassClick}
                                                hideTrainer={userRole === "regular" && !showTrainerNamesInSchedule}
                                            />
                                        </Box>
                                    </Grid>
                                );
                            })}
                        </Grid>
                    ) : (
                        <ClassSchedule
                            classes={getClassesForSelectedDay(selectedDayIndex)}
                            attendeesCount={attendeesCount}
                            onEdit={handleEditTraining}
                            onClassClick={handleClassClick}
                            weeklyView
                            hideTrainer={userRole === "regular" && !showTrainerNamesInSchedule}
                        />
                    )}
                </>
            )}

            {/* Mobile Filter FAB */}
            {isMobile && !showWODView && !showCapView && (
                <Fab
                    color="primary"
                    aria-label="filter"
                    onClick={handleFilterClick}
                    sx={{
                        position: 'fixed',
                        bottom: 90, // Above bottom navigation (70px) + 20px spacing
                        right: 16,
                        zIndex: 1100,
                        boxShadow: 4,
                        '&::after': selectedFilters.length > 0 ? {
                            content: `"${selectedFilters.length}"`,
                            position: 'absolute',
                            top: -4,
                            right: -4,
                            backgroundColor: 'error.main',
                            color: 'white',
                            borderRadius: '50%',
                            width: 24,
                            height: 24,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: '0.75rem',
                            fontWeight: 'bold',
                            border: '2px solid white'
                        } : {}
                    }}
                >
                    <FilterListIcon />
                </Fab>
            )}

            {/* Filter Menu */}
            {!showWODView && !showCapView && (
                <Menu
                    anchorEl={filterAnchorEl}
                    open={Boolean(filterAnchorEl)}
                    onClose={handleFilterClose}
                    PaperProps={{
                        sx: {
                            maxHeight: 400,
                            width: 280
                        }
                    }}
                >
                    <Box sx={{ px: 2, py: 1, borderBottom: 1, borderColor: 'divider', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography variant="subtitle1" fontWeight="bold">
                            Filter by Type
                        </Typography>
                        {selectedFilters.length > 0 && (
                            <Button size="small" onClick={handleClearFilters}>
                                Clear
                            </Button>
                        )}
                    </Box>
                    {trainingTypeOptions.map((type) => (
                        <MenuItem
                            key={type}
                            onClick={() => handleFilterToggle(type)}
                            dense
                        >
                            <Checkbox
                                checked={selectedFilters.includes(type)}
                                size="small"
                            />
                            <ListItemText primary={type} />
                        </MenuItem>
                    ))}
                </Menu>
            )}

            <TrainingModal
                open={isTrainingModalOpen}
                onClose={() => setTrainingModalOpen(false)}
                onSave={handleSaveTraining}
                selectedClass={selectedTraining}
                trainers={trainers}
            />

            <ClassDetailsModal
                key={`class-${selectedClass?.id}`}
                open={isClassModalOpen}
                onClose={handleClassModalClose}
                onExited={handleClassModalExited}
                onRegistrationSuccess={handleRegistrationSuccess}
                cls={selectedClass}
                onEdit={handleEditClass}
                onDelete={handleDeleteClass}
                refreshClasses={fetchClasses}
                attendeesCount={attendeesCount[selectedClass?.id]}
                affiliateId={affiliateId}
                affiliateEmail={affiliateEmail}
                trainers={trainers}
                registrationPeriod={registrationPeriod}
                selectedAffiliateListVisible={selectedAffiliate ? selectedAffiliate.isClassListVisible : false}
                isAllClassListVisible={isAllClassListVisible}
                workoutInfoVisibilityMode={workoutInfoVisibilityMode}
                hideTrainer={userRole === "regular" && !showTrainerNamesInSchedule}
                cancelBeforeHours={cancelBeforeHours}
                refreshKey={classModalRefreshKey}
            />

            <TrainerAssignmentModal
                open={isTrainerAssignmentOpen}
                onClose={() => setTrainerAssignmentOpen(false)}
                trainers={trainers}
                dayClasses={dayClasses}
                selectedTrainer={selectedTrainer}
                selectedDate={selectedAssignmentDate}
                selectedClassIds={selectedClassIds}
                onTrainerChange={handleTrainerChange}
                onDateChange={handleDateChange}
                onClassCheckboxChange={handleClassCheckboxChange}
                onAssign={handleAssignTrainer}
            />

            {/* Day Leaderboard Modal */}
            <Dialog
                open={isDayLeaderboardOpen}
                onClose={() => setDayLeaderboardOpen(false)}
                maxWidth={false} // Muuda "md" asemel "false"
                fullWidth
                PaperProps={{
                    sx: {
                        m: {xs: 0},  // Mobiilis eemaldame ääred
                        width: {xs: '100%'},  // Mobiilis täislaius
                        maxWidth: {xs: '100%'},  // Mobiilis täislaius
                        borderRadius: {xs: 0}  // Mobiilis eemaldame ümarad nurgad
                    }
                }}
            >
                <DialogTitle>
                    <Box display="flex" alignItems="center">
                        <EmojiEventsIcon sx={{color: "goldenrod", mr: 1}}/>
                        <Typography variant="h6">
                            Daily WOD Leaderboard - {getFormattedDate()}
                        </Typography>
                    </Box>
                </DialogTitle>
                <DialogContent>
                    {/* Filter buttons */}
                    <ToggleButtonGroup
                        value={dayLeaderboardFilter}
                        exclusive
                        onChange={handleDayLeaderboardFilterChange}
                        aria-label="Filter results"
                        size="small"
                        sx={{mb: 2}}
                    >
                        <ToggleButton value="all">All</ToggleButton>
                        <ToggleButton value="rx">Rx</ToggleButton>
                        <ToggleButton value="sc">Sc</ToggleButton>
                        <ToggleButton value="beg">Beg</ToggleButton>
                    </ToggleButtonGroup>

                    {/* Show loading indicator or data table */}
                    {loadingLeaderboard ? (
                        <Box display="flex" justifyContent="center" my={3}>
                            <CircularProgress/>
                        </Box>
                    ) : filteredDayLeaderboard.length > 0 ? (
                        <TableContainer component={Paper}>
                            <Table size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Class</TableCell>
                                        <TableCell>Name</TableCell>
                                        <TableCell>
                                            Score
                                            <Typography
                                                component="span"
                                                color="text.secondary"
                                                sx={{ml: 1, fontSize: '0.9em'}}
                                            >
                                                (previous)
                                            </Typography>
                                        </TableCell>
                                        <TableCell>Type</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {filteredDayLeaderboard.map((entry, index) => (
                                        <TableRow
                                            key={`${entry.id}-${index}`}
                                            // Highlight the current user's row
                                            sx={entry.fullName === userFullName ? {
                                                backgroundColor: 'rgba(25, 118, 210, 0.08)'
                                            } : {}}
                                        >
                                            <TableCell>
                                                <Typography variant="body2" sx={{fontWeight: 'bold'}}>
                                                    {entry.classTime}
                                                </Typography>

                                            </TableCell>
                                            <TableCell>{entry.fullName}</TableCell>
                                            <TableCell>
                                                <Box>
                                                    <div>
                                                        <strong>{entry.score}</strong>
                                                        {entry.previousScore && (
                                                            <Typography
                                                                component="span"
                                                                color="text.secondary"
                                                                sx={{ml: 1, fontSize: '0.9em'}}
                                                            >
                                                                ({entry.previousScore})
                                                            </Typography>
                                                        )}
                                                    </div>
                                                    {entry.comment && (
                                                        <Typography
                                                            variant="body2"
                                                            color="text.secondary"
                                                            sx={{
                                                                fontSize: '0.75em',
                                                                fontStyle: 'italic',
                                                                mt: 0.5,
                                                                lineHeight: 1.2
                                                            }}
                                                        >
                                                            {entry.comment}
                                                        </Typography>
                                                    )}
                                                </Box>
                                            </TableCell>
                                            <TableCell>{entry.scoreType?.toUpperCase()}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    ) : (
                        <Typography align="center">
                            No results available for the selected filter.
                        </Typography>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setDayLeaderboardOpen(false)} color="primary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Delete Confirmation Dialog */}
            <Dialog
                open={confirmDialogOpen}
                onClose={() => setConfirmDialogOpen(false)}
            >
                <DialogTitle>Confirm Deletion</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to delete this class? This action cannot be undone.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setConfirmDialogOpen(false)} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={handleConfirmDeleteClass} color="error">
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Success Dialog */}
            <Dialog
                open={successDialogOpen}
                onClose={() => setSuccessDialogOpen(false)}
            >
                <DialogTitle>Success</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {dialogMessage}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setSuccessDialogOpen(false)} color="primary">
                        OK
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Error Dialog */}
            <Dialog
                open={errorDialogOpen}
                onClose={() => setErrorDialogOpen(false)}
            >
                <DialogTitle>Error</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {dialogMessage}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setErrorDialogOpen(false)} color="primary">
                        OK
                    </Button>
                </DialogActions>
            </Dialog>

            {/* User Registrations Modal */}
            <Dialog
                open={isRegistrationsModalOpen}
                onClose={() => setRegistrationsModalOpen(false)}
                maxWidth={false}
                fullWidth
                PaperProps={{
                    sx: {
                        m: {xs: 0},
                        width: {xs: 'calc(100% - 16px)', sm: 'auto', md: '1200px'},
                        maxWidth: {xs: '100%', sm: '600px'},
                    }
                }}
            >
                <DialogTitle>
                    <Box display="flex" alignItems="center">
                        <EventAvailable sx={{mr: 1, color: "primary.main"}}/>
                        <Typography variant="h6">
                            My Future Classes
                        </Typography>
                    </Box>
                </DialogTitle>
                <DialogContent sx={{pl: 0, pr: 0}}>
                    {loadingRegistrations ? (
                        <Box display="flex" justifyContent="center" my={3}>
                            <CircularProgress />
                        </Box>
                    ) : userRegistrations.length > 0 ? (
                        <Box sx={{ width: "100%", pb: 0, pt: 2 }}>
                            {userRegistrations.map((registration) => {
                                const classTime = new Date(registration.time);
                                const now = new Date();
                                const isPastClass = now > classTime;

                                return (
                                    <Card
                                        key={`${registration.id}-${registration.registeredAt || registration.waitlistedAt}`}
                                        sx={{
                                            cursor: "pointer",
                                            ":hover": { boxShadow: isPastClass ? 2 : 6 },
                                            bgcolor: getBackgroundColor(registration.trainingType),
                                            width: "100%",
                                            mb: 2,
                                            p: 0,
                                            position: "relative",
                                            opacity: isPastClass ? 0.6 : 1,
                                            filter: isPastClass ? 'grayscale(70%)' : 'none',
                                            transition: 'all 0.3s ease',
                                            border: registration.isInWaitlist ? '2px dashed #ff9800' : '1px solid rgba(0, 0, 0, 0.12)',
                                        }}
                                        onClick={() => handleClassClick(registration)}
                                    >
                                        {/* Waitlist Badge */}
                                        {registration.isInWaitlist && (
                                            <Box
                                                sx={{
                                                    position: 'absolute',
                                                    top: 8,
                                                    right: 8,
                                                    bgcolor: 'orange',
                                                    color: 'white',
                                                    px: 1,
                                                    py: 0.5,
                                                    borderRadius: 1,
                                                    fontSize: '0.75rem',
                                                    fontWeight: 'bold'
                                                }}
                                            >
                                                WAITLIST
                                            </Box>
                                        )}

                                        <CardContent sx={{ p: 1, "&:last-child": { pb: 1, ml: 0 } }}>
                                            <Grid container spacing={2} alignItems="center">
                                                <Grid item xs={4}>
                                                    <Box display="flex" flexDirection="column" alignItems="flex-start">
                                                        <Box display="flex" alignItems="center">
                                                            <AccessTimeIcon sx={{ mr: 1, fontSize: 20 }} />
                                                            <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                                                                {formatClassTimeOnly(registration.time)}
                                                            </Typography>
                                                        </Box>
                                                        <Typography variant="caption" color="textSecondary">
                                                            {formatClassDate(registration.time)}
                                                        </Typography>
                                                        {registration.duration && (
                                                            <Typography variant="caption" color="textSecondary">
                                                                {registration.duration} min
                                                            </Typography>
                                                        )}
                                                    </Box>
                                                </Grid>

                                                <Grid item xs={8}>
                                                    <Typography variant="h6" sx={{ fontSize: "1rem", fontWeight: "bold" }}>
                                                        {registration.trainingName}

                                                    </Typography>

                                                    <Box display="flex" alignItems="center" sx={{ mt: 0.5 }}>
                                                        <PersonIcon sx={{ mr: 1, fontSize: 16 }} />
                                                        <Typography variant="body2">
                                                            {registration.trainer || "N/A"}
                                                        </Typography>
                                                    </Box>

                                                    <Typography variant="body2" color="primary.main" sx={{ mt: 0.5 }}>
                                                        {registration.affiliate?.name || 'Unknown Gym'}
                                                    </Typography>

                                                    {registration.isFamilyMember && (
                                                        <Typography variant="caption" color="text.secondary" display="block">
                                                            Family Member: {registration.familyMember?.fullName || 'Family Member'}
                                                        </Typography>
                                                    )}


                                                </Grid>
                                            </Grid>
                                        </CardContent>
                                    </Card>
                                );
                            })}
                        </Box>
                    ) : (
                        <Typography align="center" color="text.secondary">
                            You have no upcoming registered classes or waitlist entries.
                        </Typography>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setRegistrationsModalOpen(false)} color="primary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
            {/* Cancel Future Class Confirmation Dialog */}
            <Dialog
                open={cancelFutureClassConfirmOpen}
                onClose={handleCloseCancelFutureClass}
            >
                <DialogTitle>Confirm Cancellation</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to cancel your registration for "{selectedClassToCancel?.trainingName}"
                        on {selectedClassToCancel ? formatClassTime(selectedClassToCancel.time) : ''}?
                        {selectedClassToCancel?.isFamilyMember && (
                            <span><br/>This will cancel the registration for your family member.</span>
                        )}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseCancelFutureClass} variant="contained" color="primary">
                        No, Keep Registration
                    </Button>
                    <Button onClick={handleConfirmCancelFutureClass} color="error" variant="outlined">
                        Yes, Cancel Registration
                    </Button>
                </DialogActions>
            </Dialog>
            <Snackbar
                open={notificationOpen}
                autoHideDuration={6000}
                onClose={() => setNotificationOpen(false)}
                anchorOrigin={{vertical: 'top', horizontal: 'center'}}
                sx={{
                    zIndex: 9999,
                    top: '60px !important'
                }}
            >
                <Alert
                    onClose={() => setNotificationOpen(false)}
                    severity={notificationSeverity}
                    sx={{width: '100%'}}
                >
                    {notificationMessage}
                </Alert>
            </Snackbar>
        </Container>


    );

}